module.exports = __webpack_public_path__ + "static/media/af.b7494e9a.svg";